import accounting from 'accounting'

export const getFormattedNumber = (value, precision = { thousand: ' ' }) => accounting.formatNumber(value, precision)
